import React from "react";
import { classNames, responsiveClassNames } from "../../utilities/helpers.js";
import s from "./Divider.module.css";
const Divider = (props) => {
    const { vertical, blank, className, attributes } = props;
    const rootClassNames = classNames(s.root, className, blank && s["--blank"], ...responsiveClassNames(s, "--vertical", vertical));
    // Only support aria-orientation for non-responsive dividers
    let ariaOrientation;
    if (typeof vertical === "boolean" || vertical === undefined) {
        ariaOrientation = vertical ? "vertical" : "horizontal";
    }
    return (React.createElement("div", { ...attributes, role: "separator", "aria-orientation": ariaOrientation, className: rootClassNames }));
};
export default Divider;
